import {retrySite} from '@/api/sites';
import {useMutation, useQueryClient} from '@tanstack/react-query';

export function useRetrySite() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (siteId: string) => retrySite(siteId),
        onSuccess: async (_data, siteId) => {
            queryClient.invalidateQueries({queryKey: ['sites']});
            // Await refetch so isLoading stays true until fresh status is cached.
            // The backend synchronously flips status to 'provisioning' before returning,
            // so the refetch returns the new state and the UI transitions cleanly.
            await queryClient.refetchQueries({queryKey: ['site-status', siteId]});
        }
    });
}
